import React from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "~/stores";
import {FilterChipPopover} from "./FilterChipPopover";
import {MonthRangePicker} from "./MonthRangePicker";
import {formatMonthRange, toDateRange, toMonthRange} from "./monthRange";

/**
 * Date filter by whole months: presets on the left, a month grid on the right
 * (click the first and the last month). Staged like the other filters.
 */
export const DateRangeFilter: React.FC = observer(() => {
    const {bagStore} = useStores();
    const filterStore = bagStore.advanced.filterStore;
    const applied = toMonthRange(filterStore.editingFilters.date_range);
    const defaultRange = toMonthRange(filterStore.initialFilter?.date_range);

    return <FilterChipPopover label="Date" status={formatMonthRange(applied)} active={Boolean(applied)}>
        {close => <MonthRangePicker
            value={applied}
            defaultRange={defaultRange}
            onCancel={close}
            onOk={range => {
                filterStore.stage({date_range: range ? toDateRange(range) : undefined});
                close();
            }}/>}
    </FilterChipPopover>;
});
